import React from 'react';
import { getStatusLabel, getStatusTone } from '../../utils/directOrderStatus';

// Status as a coloured word with a dot; the dot shape carries the state too so it
// does not rely on colour alone.
const Dot = ({ tone }) => (
  <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true">
    {tone === 'pending' ? (
      <circle cx="4" cy="4" r="3" fill="none" stroke="currentColor" strokeWidth="1.5" />
    ) : (
      <circle cx="4" cy="4" r="4" fill="currentColor" />
    )}
  </svg>
);

const StatusBadge = ({ order }) => {
  const tone = getStatusTone(order);
  return (
    <span className={`do-status do-status--${tone}`}>
      <Dot tone={tone} />
      {getStatusLabel(order)}
    </span>
  );
};

export default StatusBadge;
